import {Address} from './address';

export class REO {
  sPropertyType = 0;
  sPropertyTypeDesc = "";
  sDispositionType = 0;
  sOccupancyType = 0;
  sOccupancyDesc = "";
  sSubjectFlag: boolean;
  sCurrentFlag: boolean;
  sMarketValue: number;
  sMortgageLien: number;
  sMortgagePayment: number;
  sTaxExpense: number;
  sGrossRental: number;
  sOccupancyRate: number;
  sNetRentalIncome: number;
  sAddress : Address = new Address();
  sLiabilities = [];
  sLiabilityDummyId ="";
  uiArrow = "arrow-down-outline";
  uiExpanderText="Expand";
  uiShow =  false;
  id : string;
}

